import { render, staticRenderFns } from "./BibRendering.vue?vue&type=template&id=3fef57c2&scoped=true&"
import script from "./BibRendering.vue?vue&type=script&lang=js&"
export * from "./BibRendering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef57c2",
  null
  
)

export default component.exports